/**
 * Function builds a VIP ad url
 * @returns string
 */

export default function getAdUrl(): string {
  return `${window.location.origin}${window.location.pathname}`;
}
